import "@ncp/ui/fonts";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { I18nProvider, createI18n, loadProcedurePeriods } from "@ncp/i18n";
import { App } from "./App";
import backofficeEn from "./locales/en";
import backofficeAr from "./locales/ar";

const i18n = createI18n({
  resources: {
    en: { backoffice: backofficeEn },
    ar: { backoffice: backofficeAr },
  },
});

// The procedures' periods the screens name, from their one definition on the server (condition 2.14).
void loadProcedurePeriods(i18n, import.meta.env.VITE_API_URL ?? "");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  </StrictMode>,
);
